import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { idleAndStandByMapper } from '../../../components/CoreSettings/utils/IdleAndStandByMapper'
import { IGeneralSettings } from '../../../types/settings'
import { convertEmptyValuesToNull } from '../../../components/CoreSettings/utils/convertEmptyValuesToNull'
import { hideRightBar } from '../../actions/rightBarActions'
import { fetchProductGeneralSettings } from './fetchProductGeneralSettings'
import { getUrlWithVersion } from '../../../api/api'

export const updateProductGeneralSettings = createAsyncThunk<
    void,
    { guid: string; generalSettings: IGeneralSettings },
    ThunkConfig<string>
>('coreSettingsSlice/updateProductGeneralSettings', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { guid, generalSettings } = args
    try {
        const data = idleAndStandByMapper(generalSettings)
        convertEmptyValuesToNull(data)

        await api.put(
            getUrlWithVersion(`/products/${guid}/core_settings/general`),
            data
        )

        throwSuccessMessage('General settings successfully updated')
        dispatch(fetchProductGeneralSettings({ guid }))
        dispatch(hideRightBar())
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('General settings update failed')
    }
})
